import React, {useContext, useEffect, useState} from 'react';

import {AppContext} from '../../../AppModule/Context';
import {withWidgetContext} from '../widgetContextProvider';

import AnimatedLogoComponent from '../../common/genericComponents/animatedLogoComponent';

import analyticsService from '../../../services/analyticsService';
import utilsService from '../../../services/utilsService';

import VIDABOO_CONSTANTS from '../../../config/consts';
import consoltoLogo from '../../../assets/svg/icons/consolto-logo-grey.svg';

import './poweredByConsoltoComponent.css';

const PoweredByConsoltoComponent = ({
  isDemo = false,
  category = null,
  eventAction = null,
  mentorDto = null,
  utmMedium = null,
  widgetContext = {},
  onPoweredByConsoltoClick = () => {},
}) => {
  const context = useContext(AppContext);
  const [hrefLink, setHrefLink] = useState(null);

  useEffect(() => {
    const hrefLink = getHrefLink();
    setHrefLink(hrefLink);
  }, [utmMedium]);

  const getHrefLink = () => {
    //TODOWCRS : utmMedium should be based on link in address bar because in personal page mobile view, get consolto is shown on right bottom part
    switch (utmMedium) {
      case VIDABOO_CONSTANTS.UTM_MEDIUMS.MEDIA:
        return generateLink(
          VIDABOO_CONSTANTS.UTM_MEDIUMS.MEDIA,
          VIDABOO_CONSTANTS.UTM_CAMPAIGNS.MEDIA_BTN,
        );
      case VIDABOO_CONSTANTS.UTM_MEDIUMS.PERSONAL_PAGE:
        return generateLink(
          VIDABOO_CONSTANTS.UTM_MEDIUMS.PERSONAL_PAGE,
          VIDABOO_CONSTANTS.UTM_CAMPAIGNS.PERSONAL_PAGE_BTN,
        );
      case VIDABOO_CONSTANTS.UTM_MEDIUMS.SCHEDULING:
        return generateLink(
          VIDABOO_CONSTANTS.UTM_MEDIUMS.SCHEDULING,
          VIDABOO_CONSTANTS.UTM_CAMPAIGNS.SCHEDULING_BTN,
        );
      case VIDABOO_CONSTANTS.UTM_MEDIUMS.WIDGET:
        return generateLink(
          VIDABOO_CONSTANTS.UTM_MEDIUMS.WIDGET,
          VIDABOO_CONSTANTS.UTM_CAMPAIGNS.WIDGET_BTN,
        );
      case VIDABOO_CONSTANTS.UTM_MEDIUMS.MEETING_ROOM:
        return generateLink(
          VIDABOO_CONSTANTS.UTM_MEDIUMS.MEETING_ROOM,
          VIDABOO_CONSTANTS.UTM_CAMPAIGNS.MEETING_ROOM_BTN,
        );
      default:
        return generateLink('Unknown', 'Unknown');
    }
  };

  const generateLink = (utmMedium, utmCampaign) => {
    return `${VIDABOO_CONSTANTS.HomePage}?utm_source=${VIDABOO_CONSTANTS.UTM_SOURCES.CONSOLTO}&utm_medium=${utmMedium}&utm_campaign=${utmCampaign}`;
  };

  const handleGetConsoltoClick = () => {
    if (eventAction && category && widgetContext.widgetDto) {
      sendGA();
    }
    window.open(hrefLink, '_blank');
    onPoweredByConsoltoClick();
  };

  const sendGA = () => {
    const enableWidgetAnalyticsForward =
      !utilsService.getIsPersonalPage() &&
      widgetContext.widgetDto.widgetAppCtrlDto.enableWidgetAnalyticsForward;
    analyticsService.trackEvent({
      category,
      action: eventAction,
      label:
        mentorDto?.profileName ?? widgetContext.widgetDto.widgetAppCtrlDto.name,
      value: '',
      sendToParent: enableWidgetAnalyticsForward === true,
    });
    sendCA();
  };

  const sendCA = () => {
    analyticsService.saveConsoltoAnalyticsEvent({
      category,
      action: eventAction,
      senderCreationTime: new Date().getTime(),
      userId: context.currentUser.userId,
      mentorId: mentorDto?.mentorId,
      userRole: context.currentUser.role,
      error: false,
      dimensionsMap: {
        widget: utilsService.getIsInWidget(),
        widgetId: widgetContext.widgetDto.widgetId,
        senderIsMentor: context.currentUser.isActive,
      },
    });
  };

  return utilsService.getIsInWidget() ||
    context.windowScreenSize === VIDABOO_CONSTANTS.SCREEN_SIZE.MOBILE ||
    isDemo ? (
    <div className="et-powered-by-consolto-container-widget">
      <div className="et-pbccw-img-text-wrap" onClick={handleGetConsoltoClick}>
        <div className="et-pbccw-consolto-img">
          <AnimatedLogoComponent />
        </div>
        <a
          className="et-pbccw-get-consolto-text"
          href={hrefLink}
          target="_blank"
          rel="noopener noreferrer">
          {context.languageSet.CONSOLTO_WIDGET.POWERED_BY_CONSOLTO}
        </a>
      </div>
    </div>
  ) : (
    <div
      className="et-powered-by-consolto-container"
      onClick={handleGetConsoltoClick}>
      <div className="et-pbcc-consolto-img">
        <img src={consoltoLogo} alt="consoltoLogo" />
      </div>
      <div className="et-pbcc-consolto-txt">
        {context.languageSet.CONSOLTO_WIDGET.POWERED_BY_CONSOLTO}
      </div>
    </div>
  );
};

export default withWidgetContext(PoweredByConsoltoComponent);
